import { Autoplay, Navigation, Pagination, Keyboard, EffectFade, Mousewheel } from "swiper";


export const cardSliderOptions = {
  modules: [Navigation, Pagination, Autoplay, EffectFade],
  slidesPerView: 1,
  spaceBetween: 10,
  grabCursor: true,
  speed: 1500,
  navigation: {
    nextEl: ".card-slider .swiper-button-next",
    prevEl: ".card-slider .swiper-button-prev",
  },
  pagination: {
    el: ".image-swiper-pagination",
    clickable: true,
    type: "fraction",
  },
  autoplay: false,
  on: {
    init: function () {
      const paginationCurrent = document.querySelector(".card-slider .swiper-pagination-fraction .swiper-pagination-current") as HTMLElement;
      paginationCurrent.nextSibling?.replaceWith(" | ");
    }
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 18,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 18,
    },
    1400: {
      slidesPerView: 3,
      spaceBetween: 18,
    },
    1600: {
      slidesPerView: 3,
      spaceBetween: 18,
    }
  },
}
